/* eslint-disable max-len */
import { I18n } from 'react-redux-i18n';

async function haveEqualLimits(limits) {
  for (let i = 0; i < limits.length; i += 1) {
    const equal = limits.find((limit, index) => ((Number(limit.limit) === Number(limits[i].limit) && i !== index)));
    if (equal) return true;
  }
  return false;
}

async function validation(form, goalOff, settings = {}, file) {
  const {
    clientId,
    status,
    freight,
    locationId,
    places,
    deposit,
    mainDeposit,
    bu,
    pricePolicy,
    purpose,
    emails,
    buyButtonLabel,
    fileEmailXml,
    fileEmailCsv,
    fileEmailPdf,
    fileEmailJson,
    nickname,
    displayClientDescription,
    showContractProductWithoutPrice,
    allowSellSpotItensWithoutStock,
    clientWithdraw,
    limits,
    minimumPurchase,
    minimumProduct,
    orderType,
    autoBilling,
    customerUnit,
    projectsForIntegrators,
    punchoutRule,
    punchoutN2Rule,
    punchoutVendorId,
    newItemVendor,
    newItemContract,
    productCatalogPunchout,
    punchoutCatalogName,
    newLogoUrl,
    deliveryAddressType,
    internalDeliveryAddress,
  } = form;

  if (!clientId) return { message: I18n.t('clientNotSelected') };
  if (!freight) return { message: I18n.t('freightNotSelected') };
  if (settings.companyTag === 'dimensional') {
    if (!places && settings.companyTag === 'nortel') return { message: I18n.t('placeNotSelected') };
    if (!locationId) return { message: I18n.t('mainPlaceNotSelected') };
  } else if (!locationId) return { message: I18n.t('placeNotSelected') };
  if (!bu && bu !== 0) return { message: I18n.t('buNotSelected') };
  if (settings.companyTag !== 'nortel' && !pricePolicy && pricePolicy !== 0) return { message: I18n.t('policyNotSelected') };
  if (!purpose && !goalOff) return { message: I18n.t('golNotSelected') };
  if (!deposit) return { message: I18n.t('depositNotSelected') };
  if (settings.companyTag && settings.companyTag !== 'chile' && !mainDeposit) return { message: I18n.t('mainDepositNotSelected') };
  if (!emails) return { message: I18n.t('emailNotAdded') };
  if (!buyButtonLabel) return { message: I18n.t('buttonNotInserted') };
  if (displayClientDescription === null
    || displayClientDescription === ''
    || displayClientDescription === undefined) { return { message: I18n.t('showDescription') }; }
  if (showContractProductWithoutPrice === null
    || showContractProductWithoutPrice === ''
    || showContractProductWithoutPrice === undefined) {
    return { message: I18n.t('showContractProductWithoutPriceError') };
  }
  if (allowSellSpotItensWithoutStock === null
    || allowSellSpotItensWithoutStock === ''
    || allowSellSpotItensWithoutStock === undefined) {
    return { message: I18n.t('allowSellSpotItensWithoutStockError') };
  }

  if (orderType === null
    || orderType === ''
    || orderType === undefined) {
    return { message: I18n.t('orderTypeError') };
  }

  if (autoBilling === null
    || autoBilling === ''
    || autoBilling === undefined) {
    return { message: I18n.t('autoBillingError') };
  }

  if (customerUnit === null
    || customerUnit === ''
    || customerUnit === undefined) {
    return { message: I18n.t('customerUnitError') };
  }

  if (settings.companyTag === 'chile'
    && (projectsForIntegrators === null
    || projectsForIntegrators === ''
    || projectsForIntegrators === undefined)) {
    return { message: I18n.t('projectsForIntegratorsError') };
  }

  if (!!productCatalogPunchout && punchoutCatalogName.trim() === '') {
    return { message: I18n.t('catalogNameError') };
  }

  if (await haveEqualLimits(limits)) {
    return { message: I18n.t('limitError') };
  }

  if (file && file.name) {
    const validExtensions = ['png', 'jpeg', 'jpg'];
    const fileExtension = file.type.split('/').pop();

    if (!validExtensions.includes(fileExtension)) {
      return { message: I18n.t('InvalidFileExtension') };
    }
  }

  return {
    clientId,
    status,
    freight,
    locationId,
    places,
    deposit,
    mainDeposit,
    bu,
    pricePolicy,
    purpose,
    emails,
    buyButtonLabel,
    fileEmailXml,
    fileEmailCsv,
    fileEmailPdf,
    fileEmailJson,
    displayClientDescription,
    showContractProductWithoutPrice,
    clientWithdraw,
    nickname,
    allowSellSpotItensWithoutStock,
    limits,
    minimumPurchase,
    minimumProduct,
    orderType,
    autoBilling,
    customerUnit,
    projectsForIntegrators,
    punchoutRule,
    punchoutN2Rule,
    punchoutVendorId,
    newItemVendor,
    newItemContract,
    productCatalogPunchout,
    punchoutCatalogName,
    newLogoUrl,
    deliveryAddressType,
    internalDeliveryAddress,
  };
}

export default {
  validation,
};
